module.exports = __webpack_public_path__ + "img/web_36.bad6870b.png";